function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_68357",
  "data-name": "Group 68357"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52422",
  "data-name": "Path 52422",
  d: "M15.969,4.577h0A5.6,5.6,0,0,0,11,10.137v.354h0a6.6,6.6,0,0,1,4.969-2.384V9.975h0a.708.708,0,0,0,1.146.556L21.74,6.878h0a.682.682,0,0,0,0-1.072L17.115,2.154h0a.707.707,0,0,0-1.146.555Z",
  fill: "none",
  stroke: "#1dbf73",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52423",
  "data-name": "Path 52423",
  d: "M21,12v4h0a5,5,0,0,1-5,5H8a5,5,0,0,1-5-5H3V8H3A5,5,0,0,1,8,3h3",
  fill: "none",
  stroke: "#1dbf73",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52424",
  "data-name": "Path 52424",
  d: "M0,0H24V24H0Z",
  fill: "none"
});

function SvgShareArrowSquare1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share-arrow-square.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareArrowSquare1);
export default __webpack_public_path__ + "static/media/share-arrow-square.1.cd79deea.svg";
export { ForwardRef as ReactComponent };